// extracted by mini-css-extract-plugin
module.exports = {"addCompanyWrp":"addCompany_addCompanyWrp__2bEvI","modalTooltip":"addCompany_modalTooltip__3vDbw","loaderWrp":"addCompany_loaderWrp__2colk"};